// extracted by mini-css-extract-plugin
module.exports = {"base":"Fullpage_base__1e6Eb","background":"Fullpage_background__1lDvs"};